/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { YukkApi } from '../../../service/yukkapi.service';
import { RoutingService } from 'src/app/service/routing.service';
import { NewsService } from 'src/app/shared/services/data-api/news.service';
import { SentimentService } from 'src/app/shared/services/data-api/sentiment.service';
import { StoriesService } from 'src/app/shared/services/data-api/stories.service';

/**
 * iframe widget display the single component
 */
@Component({
  selector: 'app-widget-iframe',
  templateUrl: './widget-iframe.component.html',
  styleUrls: ['./widget-iframe.component.scss'],
})
export class WidgetIframeComponent {
  /**
   * query parameters url
   */
  params: any;

  previousValue: any;

  /**
   * basic info of the entity
   */
  $titolo: Observable<YukkApi>;

  /**
   * basic info for the news reader
   */
  article: any;

  /**
   * data for the story reader
   */
  newsfeedStory: any;

  /**
   * basic info for the news reader
   */
  match: any;

  /**
   * basic info for the news reader
   */
  tag: any;
  /**
   * quick fix for now to style the chat iframe
   */
  topLocationIsChat: boolean;

  /**
   * query parameters subscribe and info data request
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private yukkApi: YukkApi,
    public routing: RoutingService,
    private newsService: NewsService,
    private sentimentService: SentimentService,
    private storiesService: StoriesService,
  ) {
    this.route.queryParams.subscribe((params) => {
      if (params.isin) {
        this.yukkApi.isinParse([params.isin]).subscribe((result) => {
          const isinObject = Object.values(result)[0];
          if (isinObject && isinObject['compound_key']) {
            const type = isinObject['compound_key'].split(':')[0];
            const id = isinObject['compound_key'].split(':')[1];
            this.router.navigate([], {
              queryParams: {
                isin: null,
                type: type,
                id: id,
              },
              queryParamsHandling: 'merge',
              replaceUrl: false,
            });
          }
        });
      } else if (params.type === 'portfolio' && params.id) {
        router.navigate(['/widget/portfolio/chart'], {
          queryParams: {
            id: params.id,
            feed: params.feed,
          },
          queryParamsHandling: '',
          replaceUrl: false,
        });
      } else if (params.type === 'portfolio' && params.name) {
        router.navigate(['/widget/portfolio/chart'], {
          queryParams: {
            feed: params.feed,
            name: params.name,
            entities: params.entities,
          },
          queryParamsHandling: '',
          replaceUrl: false,
        });
      }
      this.params = params;
      this.$titolo = this.sentimentService.getSentiment(this.params, true);
      if (this.routing.isReader() && params.news) {
        if (params.type && params.id) {
          this.match = params.type + ':' + params.id;
        }
        if (params.tag) {
          this.tag = params.tag;
        }
        this.newsService.getNewsItem(params.news, params).subscribe(
          (result) => {
            this.article = result;
          },
          () => {
            if (params.redirectURL) {
              const redirectURL = decodeURIComponent(params.redirectURL);
              window.location.href = redirectURL;
            } else {
              this.newsService
                .getNewsItem(
                  params.news,
                  Object.assign({}, params, {
                    time: params.time ? params.time : 365,
                  }),
                )
                .subscribe(
                  (result) => {
                    this.article = result;
                  },
                  () => {
                    this.newsService
                      .getNewsItem(
                        params.news,
                        Object.assign({}, params, {
                          time: params.time ? params.time : 1095,
                        }),
                      )
                      .subscribe(
                        (result) => {
                          this.article = result;
                        },
                        () => {
                          this.router.navigate(['/message/autherror']);
                        },
                      );
                  },
                );
            }
          },
        );
      }
      if (
        this.routing.isStoryReader() &&
        params.story &&
        this.routing.reFresh(params, this.previousValue, ['story'])
      ) {
        if (params.newstype !== 'Stories') {
          this.router.navigate([], {
            queryParams: { newstype: 'Stories' },
            queryParamsHandling: 'merge',
          });
          return;
        }
        this.storiesService
          .getStoryById(params.story, {
            customParams: { min_size: 1, size: 100 },
            body: {},
          })
          .subscribe(
            (result) => {
              this.newsfeedStory = result;
            },
            () => {
              if (params.redirectURL) {
                const redirectURL = decodeURIComponent(params.redirectURL);
                window.location.href = redirectURL;
              } else {
                this.router.navigate(['/message/autherror']);
              }
            },
          );
      }
      this.previousValue = params;
      this.topLocationIsChat =
        window.top.location.pathname.split('/')[2] === 'chat';
    });
  }
}
